import { isNilOrEmpty } from 'utils'

export const getNewMessageAriaLabel = (authorName: string, messageText: string): string =>
  isNilOrEmpty(messageText) ? null : `Chat message${authorName ? ' from ' + authorName : '' }: "${messageText}"`
